<template>
<zj-layout-container>
  <zj-layout-main>
    <div class="zj-layout-main-content bgcolor scrollable" ref="container">
      舆情
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
export default {
  name: 'ZjOpinionHome',
  controller: 'UI',
  action: 'Home'
}
</script>
